import LanguageDetector from 'i18next-browser-languagedetector'
export default function () {
  const languageDetector = new LanguageDetector()

  const languages = languageDetector.detect()

  return Array.isArray(languages) ? languages[0] : languages
}
